// import { useFeatureToggle } from 'platform/utilities/feature-toggles';
import environment from '@department-of-veterans-affairs/platform-utilities/environment';
import { isProduction } from './utils/environment';

export const envApiUrl = environment.API_URL;

export const baseURL = '/ask_va_api/v0';

// TODO: This logic assumes that the feature toggle is checked within
// a React component. Need to tweak for use as a constant.
//
// const {
//   TOGGLE_NAMES,
//   useToggleLoadingValue,
//   useToggleValue,
// } = useFeatureToggle();

// const toggleName = TOGGLE_NAMES.askVaMockApiForTesting;
// const isMockApiEnabled = useToggleValue(toggleName);
// const isLoadingFeatureFlags = useToggleLoadingValue(toggleName);

// const isLocalhost = envApiUrl === 'http://localhost:3000';
// const isToggleEnabled = !isLoadingFeatureFlags && isMockApiEnabled;
// const isProduction = environment.isProduction();

// export const mockTestingFlagForAPI =
//   (isToggleEnabled || isLocalhost) && !isProduction;

export const mockTestingFlagForAPI =
  envApiUrl === 'http://localhost:3000' ||
  envApiUrl === 'http://127.0.0.1:3000'; // enable this flag when testing locally for API calls

// Overridable for testing
export const getMockTestingFlagForAPI = () => mockTestingFlagForAPI;

export const askVaFormId = '0873';

// Tracks how a user engaged with the AI category prediction flow
export const USER_ADOPTION = {
  ERROR: 0, // assumed until the prediction call succeeds; also set on API failure
  DECLINED_SUGGESTIONS: 5, // user rejected all suggested categories ("None of these")
};

// Used when the prediction service was never called (skipped) or failed, so
// the real modelName/modelVersion returned by the service isn't available.
export const DEFAULT_MODEL_SETTINGS = {
  category: {
    modelName: 'Category',
    modelVersion: 0,
  },
};

export const ERRORED_CATEGORY_PREDICTION = {
  userAdoption: USER_ADOPTION.ERROR,
  modelName: DEFAULT_MODEL_SETTINGS.category.modelName,
  modelVersion: DEFAULT_MODEL_SETTINGS.category.modelVersion,
};

export const URL = {
  GET_CATEGORIES: `${baseURL}/categories${
    mockTestingFlagForAPI ? '?user_mock_data=true' : ''
  }`,
  GET_TOPICS: `${baseURL}/categories/%PARENT_ID%/topics${
    mockTestingFlagForAPI ? '?user_mock_data=true' : ''
  }`,
  GET_SUBTOPICS: `${baseURL}/topics/%PARENT_ID%/subtopics${
    mockTestingFlagForAPI ? '?user_mock_data=true' : ''
  }`,
  ADDRESS_VALIDATION: `${baseURL}/address_validation`,
  GET_HEALTH_FACILITY: `${baseURL}/health_facilities`,
  GET_SCHOOL: `${baseURL}/education_facilities/`,
  SEND_REPLY: `/reply/new`,
  DOWNLOAD_ATTACHMENT: `${baseURL}/download_attachment?id=`,
};

// centralized logic for string replacement, incl. multiple fields
// ex: getApiUrl(URL.GET_TOPICS, { PARENT_ID: 1 })

//* @param {string} url - the URL to replace
//* @param {object} params - the object with the key(s) to replace, if any
//* @returns {string} - the URL with the replaced value(s)
export const getApiUrl = (url, params) => {
  let apiUrl = url || '';
  if (params) {
    Object.keys(params).forEach(key => {
      apiUrl = apiUrl.replace(`%${key}%`, params[key]);
    });
  }
  return envApiUrl + apiUrl;
};

export const branchesOfService = [
  'Air Force',
  'Air Force Academy',
  'Air Force Nursing Corps (AFNC)',
  'Air Force Reserves',
  'Air National Guard',
  'Army',
  'Army Air Corps or Army Air Force',
  'Army National Guard',
  'Army Reserves',
  'Coast Guard',
  'Coast Guard Academy',
  'Coast Guard Reserves',
  'Coast Guard Women’s Reserve (SPARS)',
  'Environmental Services Administration',
  'Marine Corps',
  'Marine Corps Reserves',
  'Merchant Marine',
  'National Oceanic & Atmospheric Administration',
  'Naval Academy',
  'Navy',
  'Navy Nursing Corps (NNC)',
  'Navy Reserves',
  'Other',
  // Prod CRM still expects the historical misspelling (1 r)
  // Use this until services list is pulled dynamically from CRM
  isProduction() ? 'Philippines Guerilla' : 'Philippines Guerrilla',
  'Philippines Scouts',
  'Public Health Service',
  'Space Force',
  'US Military Academy',
  'Women’s Air Force Service Pilots (WASP)',
  'Women’s Army Auxiliary Corps (WAAC)',
  'Women’s Army Corps',
  'Women’s Voluntary Emergency Service (WAVES)',
];

// Categories
export const CategoryBenefitsIssuesOutsidetheUS =
  'Benefits issues outside the U.S.';
export const CategoryDebt =
  'Debt for benefit overpayments and health care copay bills';
export const CategoryEducation = 'Education benefits and work study';
export const CategoryGuardianshipCustodianshipFiduciaryIssues =
  'Guardianship, custodianship, or fiduciary issues';
export const CategoryHealthCare = 'Health care';
export const CategoryHousingAssistanceAndHomeLoans =
  'Housing assistance and home loans';
export const CategoryVeteranReadinessAndEmployment =
  'Veteran Readiness and Employment';

// Topics
export const TopicAppraisals = 'Appraisals';
export const TopicDisabilityCompensation = 'Disability compensation';
export const TopicEducationBenefitsAndWorkStudy =
  'Education benefits and work study';
export const TopicEducationBenefitOverpayments =
  'Education benefit overpayments (for school officials)';
export const TopicEducationBenefitOverpaymentsForStudents =
  'Education benefit overpayments (for students)';
export const TopicVeteranReadinessAndEmploymentChapter31 =
  'Veteran Readiness and Employment (Chapter 31)';
export const TopicSpeciallyAdapatedHousing =
  'Specially Adapted Housing (SAH) and Special Home Adaptation (SHA) grants';

// List of categories required for Branch of service rule: https://va.ghe.com/software/va.gov-team/blob/master/products/ask-va/design/Fields%2C%20options%20and%20labels/Field%20rules.md#branch-of-service
export const branchOfServiceRuleforCategories = [
  'Veteran ID Card (VIC)',
  'Disability compensation',
  'Survivor benefits',
  'Burials and memorials',
  'Center for Women Veterans',
];

// Check to show Your Personal Information page and NOT About Yourself page
export const hasPrefillInformation = form => {
  if (!form?.aboutYourself) return false;

  const { first, last, dateOfBirth, socialOrServiceNum } = form.aboutYourself;
  return !!(
    first &&
    last &&
    dateOfBirth &&
    (socialOrServiceNum?.ssn || socialOrServiceNum?.serviceNumber)
  );
};

export const suffixes = ['Jr.', 'Sr.', 'II', 'III', 'IV'];

// Used for yes/no radio questions
export const yesNoOptions = {
  YES: 'Yes',
  NO: 'No',
};

// Relationship options for Myself
export const relationshipOptionsMyself = {
  VETERAN: "I'm the Veteran",
  FAMILY_MEMBER: "I'm a family member of a Veteran",
};

// Relationship options for SomeoneElse
export const relationshipOptionsSomeoneElse = {
  VETERAN: "I'm the Veteran",
  FAMILY_MEMBER: "I'm a family member of a Veteran",
  WORK: "I'm connected to the Veteran through my work (for example, as a School Certifying Official or fiduciary)",
};

// Contact options
export const contactOptions = {
  Phone: 'Phone call',
  Email: 'Email',
  USMail: 'U.S. mail',
};

// Tell us about your relationship to Veteran
export const aboutRelationship = {
  SPOUSE: "I'm the Veteran's spouse",
  CHILD: "I'm the Veteran's child",
  STEPCHILD: "I'm the Veteran's step child",
  PARENT: "I'm the Veteran's parent",
  NOT_LISTED: "We have a relationship that's not listed",
};

// What is your relationship to the family member
export const aboutFamilyMemberRelationship = {
  SPOUSE: "They're my spouse",
  CHILD: "They're my child",
  STEPCHILD: "They're my step child",
  PARENT: "They're my parent",
  NOT_LISTED: "We have a relationship that's not listed",
};

// What is THEIR relationship to the family member
export const aboutTheirRelationshipToVet = {
  SPOUSE: "They're the Veteran's spouse",
  CHILD: "They're the Veteran's child",
  STEPCHILD: "They're the Veteran's step child",
  PARENT: "They're the Veteran's parent",
  NOT_LISTED: "They have a relationship that's not listed",
};

// Who your question is about
export const isQuestionAboutVeteranOrSomeoneElseLabels = {
  VETERAN: 'Veteran',
  SOMEONE_ELSE: 'Someone else',
};

// Question About labels
export const whoIsYourQuestionAboutLabels = {
  MYSELF: 'Myself',
  SOMEONE_ELSE: 'Someone else',
  GENERAL: "It's a general question",
};

// Reason options
export const yourRoleOptions = {
  ACCREDITED_REP:
    'Accredited representative (such as an accredited attorney, claims agent, or Veterans Service Officer)',
  FIDUCIARY: 'Fiduciary',
  FUNERAL_DIR: 'Funeral director',
  TRAINING_OR_APPRENTICESHIP_SUP:
    'On-the-job training or apprenticeship supervisor',
  SCO: 'School Certifying Official (SCO)',
  VA_EMPLOYEE: 'VA employee',
  WORK_STUDY_SUP: 'Work study site supervisor',
  OTHER: 'Other',
};

// Reason options
export const yourRoleOptionsEducation = {
  TRAINING_OR_APPRENTICESHIP_SUP:
    'On-the-job training or apprenticeship supervisor',
  SCO: 'School Certifying Official (SCO)',
  VA_EMPLOYEE: 'VA employee',
  WORK_STUDY_SUP: 'Work study site supervisor',
  OTHER: 'Other',
};

// Chapter 1 labels: titles, questions, descriptions
export const CHAPTER_1 = {
  CHAPTER_TITLE: 'Category and topic',
  PAGE_1: {
    PATH: 'select-category',
    TITLE: 'Category',
    PAGE_DESCRIPTION: 'Category',
    QUESTION_1: 'Select the category that best describes your question:',
  },
  PAGE_2: {
    PATH: 'select-topic',
    TITLE: 'Topic',
    PAGE_DESCRIPTION: 'Topic',
    QUESTION_1: 'Select the topic that best describes your question:',
  },
  PAGE_3: {
    PATH: 'select-subtopic',
    TITLE: 'Subtopic',
    PAGE_DESCRIPTION: 'Subtopic',
    QUESTION_1: 'Select the subtopic that best describes your question:',
  },
};

// Chapter 2 labels: titles, questions, descriptions
export const CHAPTER_2 = {
  CHAPTER_TITLE: 'Your question',
  PAGE_1: {
    PATH: 'who-is-your-question-about',
    TITLE: 'Who is your question about?',
    PAGE_DESCRIPTION: '',
    QUESTION_1: 'Select who your question is about:',
  },
  PAGE_2: {
    PATH: 'reason-you-contacted-us',
    TITLE: 'Reason you contacted us',
    PAGE_DESCRIPTION: '',
    QUESTION_1: 'Select the reason you contacted us today:',
  },
  PAGE_3: {
    PATH: 'your-question',
  },
};

// Chapter 3 labels: titles, questions, descriptions
export const CHAPTER_3 = {
  CHAPTER_TITLE: 'Your Information',
  RELATIONSHIP_TO_VET: {
    PATH: 'relationship-to-veteran',
    TITLE: 'What is your relationship to the Veteran?',
    PAGE_DESCRIPTION: '',
    QUESTION_1: '',
  },
  MORE_ABOUT_YOUR_RELATIONSHIP_TO_VETERAN: {
    TITLE: 'Tell us more about your relationship',
    PAGE_DESCRIPTION: '',
    QUESTION_1: '',
  },
  THEIR_RELATIONSHIP_TO_VET: {
    TITLE: 'What is their relationship to the Veteran?',
    PAGE_DESCRIPTION: '',
    QUESTION_1: 'Describe their relationship to the Veteran',
  },
  ABOUT_THE_VET: {
    TITLE: 'Tell us about the Veteran',
    PAGE_DESCRIPTION: '',
  },
  DEATH_DATE: {
    TITLE: "Date of Veteran's death",
    PAGE_DESCRIPTION: '',
    QUESTION_1: '',
  },
  FAMILY_MEMBERS_POSTAL_CODE: {
    TITLE: "Family member's postal code",
    PAGE_DESCRIPTION: '',
    QUESTION_1:
      'Family member receives mail outside of the United States on a U.S. military base.',
    QUESTION_2: 'Post office',
    QUESTION_3: 'State',
    QUESTION_4: 'Postal code',
  },
  VETERANS_POSTAL_CODE: {
    TITLE: "Veteran's postal code",
    PAGE_DESCRIPTION: '',
    QUESTION_1:
      'Veteran receives mail outside of the United States on a U.S. military base.',
    QUESTION_2: 'Post office',
    QUESTION_3: 'State',
    QUESTION_4: 'Postal code',
  },
  YOUR_POSTAL_CODE: {
    TITLE: 'Your postal code',
    PAGE_DESCRIPTION: '',
    QUESTION_1:
      'Veteran receives mail outside of the United States on a U.S. military base.',
    QUESTION_2: 'Post office',
    QUESTION_3: 'State',
    QUESTION_4: 'Postal code',
  },
  WHO_QUES_IS_ABOUT: {
    TITLE: 'Is your question about the Veteran or someone else?',
    PAGE_DESCRIPTION: '',
  },
  VA_EMPLOYEE: {
    TITLE: 'VA employee',
    PAGE_DESCRIPTION: '',
    QUESTION_1: 'Are you currently an employee of the VA?',
  },
  ABOUT_YOURSELF: {
    TITLE: 'Tell us about yourself',
    PAGE_DESCRIPTION: '',
  },
  VA_MED_CENTER: {
    TITLE: 'VA Medical Center',
    PAGE_DESCRIPTION: '',
    QUESTION_1: '',
  },
  SCHOOL: {
    TITLE: 'School information',
    PAGE_DESCRIPTION: '',
    QUESTION_1: '',
  },
  CONTACT_INFORMATION: {
    TITLE: 'Your contact information',
    PAGE_DESCRIPTION: '',
    QUESTION_1: 'Phone number',
    QUESTION_2: 'Email address',
    QUESTION_3: 'How should we contact you?',
  },
  CONTACT_PREF: {
    TITLE: 'Your contact preference',
    PAGE_DESCRIPTION: '',
    QUESTION_1: {
      QUESTION: 'Preferred name',
      HINT: 'Let us know how we should refer to you.',
      ERROR: 'This field accepts alphabetic characters only',
    },
    QUESTION_2: {
      QUESTION: 'How should we contact you?',
      ERROR: 'Select your contact preference',
    },
  },
  YOUR_COUNTRY: {
    TITLE: 'Your country', // country
    PAGE_DESCRIPTION: '',
    QUESTION_1:
      'I live on a United States military base outside of the country',
  },
  YOUR_MAILING_ADDRESS: {
    TITLE: 'Your mailing address', // full address
    PAGE_DESCRIPTION: '',
  },
  ADDRESS_CONFIRM: {
    TITLE: 'Your address confirmation',
    PAGE_DESCRIPTION: '',
    QUESTION_1: '',
  },
  ADDRESS_VALIDATION: {
    TITLE: 'Check your mailing address',
  },
  ABOUT_YOUR_FAM_MEM: {
    TITLE: 'Tell us about your family member',
    PAGE_DESCRIPTION: '',
    QUESTION_1: '',
  },
  RELATIONSHIP_TO_FAM_MEM: {
    TITLE: 'What is your relationship to the family member?',
    PAGE_DESCRIPTION: '',
    QUESTION_1: '',
  },
  YOUR_ROLE: {
    TITLE: 'What is your role?',
  },
  STATE_OR_FACILITY: {
    TITLE: 'School information',
    PAGE_DESCRIPTION: 'Would you like to choose your school state or facility?',
    QUESTION_1: 'Select school or state facility',
  },
  SCHOOL_STATE_OR_RESIDENCY: {
    TITLE: 'School state or residency state',
    PAGE_DESCRIPTION: 'School or state of residency',
    QUESTION_1:
      "Provide your school state. If you don't have a school state, you can provide your residency state instead.",
  },
  VETERAN_LOCATION_OF_RESIDENCE: {
    TITLE: `Veteran's location of residence`,
    QUESTION_1: 'State/Province/Region',
  },
  FAMILY_MEMBERS_LOCATION_OF_RESIDENCE: {
    TITLE: `Family member's location of residence`,
    QUESTION_1: 'State/Province/Region',
  },
  YOUR_LOCATION_OF_RESIDENCE: {
    TITLE: `Your location of residence`,
    QUESTION_1: 'State/Province/Region',
  },
  YOUR_PERSONAL_INFORMATION: {
    PATH: 'your-personal-information',
    TITLE: `Your personal information`,
    DESCRIPTION: 'This is the personal information we have on file for you.',
  },
  YOUR_VA_HEALTH_FACILITY: {
    PATH: 'your-va-health-facility',
    TITLE: 'Your VA health facility',
    DESCRIPTION: 'Search by city, postal code, or use your current location.',
  },
  VETERAN_VA_HEALTH_FACILITY: {
    TITLE: "Veteran's VA health facility",
    DESCRIPTION: 'Search by city, postal code, or use your current location.',
  },
  FAMILY_MEMBER_VA_HEALTH_FACILITY: {
    PATH: 'your-va-health-facility',
    TITLE: "Family member's VA health facility",
    DESCRIPTION: 'Search by city, postal code, or use your current location.',
  },
  YOUR_VRE_INFORMATION: {
    TITLE:
      'Have you ever applied for Veteran Readiness and Employment benefits and services?',
    ERROR: "Select if you've applied for services.",
  },
  YOUR_VRE_COUNSELOR: {
    TITLE: 'Veteran Readiness and Employment counselor',
    DESCRIPTION: 'Name of your counselor:',
    ERROR: 'Enter the name of your counselor',
  },
  THEIR_VRE_INFORMATION: {
    TITLE:
      'Have they ever applied for Veteran Readiness and Employment benefits and services?',
    ERROR: "Select if they've applied for services.",
  },
  THEIR_VRE_COUNSELOR: {
    TITLE: 'Veteran Readiness and Employment counselor',
    DESCRIPTION: 'Name of their counselor:',
    ERROR: 'Enter the name of their counselor',
  },
  BRANCH_OF_SERVICE: {
    TITLE: 'Your branch of service',
    DESCRIPTION: 'Select your branch of service',
    ERROR: 'Select your branch of service',
  },
  VETERANS_BRANCH_OF_SERVICE: {
    TITLE: 'Branch of service',
    ERROR: "Select the Veteran's branch of service",
  },
};

export const noEditBtn = [
  CHAPTER_1.PAGE_1.TITLE,
  CHAPTER_1.PAGE_2.TITLE,
  CHAPTER_1.PAGE_3.TITLE,
  CHAPTER_2.PAGE_1.TITLE,
  CHAPTER_3.RELATIONSHIP_TO_VET.TITLE,
  CHAPTER_3.MORE_ABOUT_YOUR_RELATIONSHIP_TO_VETERAN.TITLE,
];

// Define the states requiring postal code
export const statesRequiringPostalCode = [
  'California',
  'New York',
  'Pennsylvania',
  'Texas',
];

// DataDog RUM configuration
export const dataDog = {
  applicationId: '2caee140-ee4a-4de5-8fe2-034c2e293b9a',
  clientToken: 'pub87c341178a0d09e2c43fad2e923930d7',
  defaultPrivacyLevel: 'mask-user-input',
  enablePrivacyForActionName: true,
  loggedIn: undefined,
  replaySampleRateNonProd: 100, // Non Production Sample %
  replaySampleRateProd: 0, // Production Sample %
  site: 'ddog-gov.com',
  service: 'ask-va',
  toggleName: 'askVADatadogRum', // Feature toggle implemented by Platform
  version: '1.0.0',
  beforeSend: event => {
    // Prevent PII from being sent to Datadog with click actions.
    if (event.action?.type === 'click') {
      // eslint-disable-next-line no-param-reassign
      event.action.target.name = 'AVA item';
    }
    return true;
  },
};
